// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__4LCIF","selected":"Chip_selected__xVhR6"};